import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IIndiceRemissivo, IPersmissaoSelect } from '../permissao';
import { PerfisService } from '../perfis.service';

@Component({
  selector: 'app-perfil-unico',
  templateUrl: './perfil-unico.component.html',
  styleUrls: ['./perfil-unico.component.scss']
})
export class PerfilUnicoComponent implements OnInit {
  @Input() indiceRemissivo!: IIndiceRemissivo;
  @Input() modoVisao!: boolean;
  @Input() userGuid!: string; 
  @Output() indiceSelecionadoEvent = new EventEmitter<IPersmissaoSelect>()

  constructor(private service: PerfisService) { }

  ngOnInit(): void {
    //console.log(this.indiceRemissivo);
  }

  /**
   * Handles the change event of a checkbox.
   * @param _t8 - The IPersmissaoSelect object.
   * @param e - The event object.
   */
  handleCheckboxChange(_t8: IPersmissaoSelect, e: any) {
    //this.marcarComoSelecionado(_t8.ids, e.target.checked);
    _t8.selecionado = e.target.checked;
    this.indiceSelecionadoEvent.emit(_t8);
  }

  /**
   * Marca ou desmarca um item como selecionado com base no número fornecido.
   * @param numero O número do item a ser marcado ou desmarcado.
   * @param checked Indica se o item deve ser marcado (true) ou desmarcado (false).
   */
  marcarComoSelecionado(numeros: number[], checked: boolean): void {
    const ultimoValor = numeros[numeros.length - 1];

    this.indiceRemissivo.permissoes.forEach((item) => {
      let s = item.ids[item.ids.length - 1];
      if ((item.ids as number[]).includes(ultimoValor)) {
        item.selecionado = checked;
        if(numeros.includes(s))
         item.selecionado = checked
      }
    });
  }

  /**
   * Formata um caminho em formato de array para uma string com setas de separação.
   * @param caminho O caminho a ser formatado.
   * @returns A string formatada com setas de separação.
   */

  formatarCaminhoLongo(p: IPersmissaoSelect): string {
    return this.service.formatarCaminho(p, this.userGuid);
  }

  /*
  formatarCaminho(caminho: string[], url?: string): string {
    var resultado = '';
    var ultima = caminho[caminho.length - 1];

    caminho.forEach((item, index) => {
      if (index == 0)
        resultado += item;
      else
        resultado += ' > ' + item;     
    });


  
  return resultado;

  //  return `${caminho.join(' > ')}`;
  }
  */
}



